<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <router-link :to="{name:'fintech.quotation'}" class="navbar-brand navbar-main">
        <h3 class="pb-0 mb-0"><span class="text-primary bad">Instituição Financeira: </span><span>{{ companyName }}</span></h3>
      </router-link>
    </div>

    <ul class="navbar-nav mr-auto">
      <span v-if="refresh" class="mt-3 alert alert-primary alert-version">
        <div class="mt-2">
          Nova versão do IntegraCargo, clique
          <span class="badge badge-black cursor-pointer" v-on:click="updatePage">{{$t('placeholders.here')}}</span>
          para atualizar
        </div>
      </span>
    </ul>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <div class="">
        <!--
          <input type="text" class="form-control" placeholder="Search...">
          <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>
        -->
        <!-- You can choose types of search input -->
        <!-- <div class="togglebutton switch-change-color mt-3">

          <base-switch v-model="darkModeSw" @input="toggleMode">
            <i class="material-icons icon-for-switch" slot="on">nights_stay</i>
            <i class="material-icons text-white icon-for-switch" slot="off">wb_sunny</i>
          </base-switch>
        </div> -->
        <div class="mt-3">
          <!-- <badge
            v-if="notifications && notifications.length > 0"
            class="float-notification"
            type="info">
            {{notifications.length}}
          </badge> -->
          <!-- <a style="cursor: pointer;" @click="showNotification()">
            <i class="tim-icons icon-bell-55 pt-1 pr-3"></i>
          </a> -->
          <!-- <a style="cursor: pointer;" @click="showNotification()">
            <i class="tim-icons icon-email-85 pt-1 pr-3"></i>
          </a> -->
          <!--          <base-switch v-model="darkModeSw" @input="toggleMode">
                      <i class="material-icons icon-for-switch" slot="on">nights_stay</i>
                      <i class="material-icons text-white icon-for-switch" slot="off">wb_sunny</i>
                    </base-switch>-->
        </div>
        <div class="arrow_box" v-if="showNotifications">
          <div class="notification-list">
            <div v-if="notifications.length === 0" class="d-flex justify-content-center mt-2">
              <p>Você não possui nenhuma notificação!</p>
            </div>
            <div v-else v-for="(notification, key) in notifications" v-bind:key="key">
              <card style="border: 2px solid; border-color: #000" class="mb-3">
                <h4 class="card-title">{{notification.attributes.text}}</h4>
                <p class="card-text">{{notification.attributes.created_at | moment("DD/MM/YYYY hh:mm")}}</p>
                <a @click="notificationRedirectTo(notification.attributes.quotation_id, notification)" href="#">Visualizar</a>
              </card>
            </div>
          </div>

        </div>
      </div>
      <modal
        :show.sync="searchModalVisible"
        class="modal-search"
        id="searchModal"
        :centered="false"
        :show-close="true"
      >
        <input
          slot="header"
          v-model="searchQuery"
          type="text"
          class="form-control"
          id="inlineFormInputGroup"
          placeholder="SEARCH"
        />
      </modal>
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template
          slot="title"
        >
          <div class="row">
            <div class="col">
              <div :class="imageSrc== '/img/placeholder.jpg'? 'photo mt-2':'photo-square'"><img :src="imageSrc"/></div>
            </div>

            <span class="mt-3 material-icons">arrow_drop_down</span>
          </div>
          <p class="d-lg-none">{{$t('pages.layout.logout') }}</p>
        </template>
        <li class="nav-link">
          <router-link :to="{name:'home.profile'}" class="nav-item dropdown-item">{{ $t('pages.layout.profile') }}</router-link>
        </li>



        <!-- TEMPORÁRIO, PARA TESTAR FUNCIONALIDADE DE IDIOMA -->
        <li class="nav-link">
          <a v-if="$i18n.locale == 'en'" class="nav-item dropdown-item" @click="$i18n.locale = 'pt'">
            <img src="https://img.icons8.com/officexs/16/000000/brazil.png"/> PT-BR
          </a>
        </li>
        <li class="nav-link">
          <a v-if="$i18n.locale == 'pt'" class="nav-item dropdown-item" @click="$i18n.locale = 'en'">
            <img src="https://img.icons8.com/officexs/16/000000/usa.png"/> EN-US
            </a>
        </li>
        <!-- ----------------------------------------------- -->




        <li class="nav-link">
          <a class="nav-item dropdown-item" @click="logoutSystem">{{ $t('pages.layout.logout') }}</a>
        </li>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions';
  import { BaseNav, Modal, Badge } from '@/resources/components';
  import SidebarToggleButton from '@/resources/layouts/SidebarToggleButton';
  import {mapActions, mapGetters} from "vuex";
  import BaseSwitch from "@/resources/components/BaseSwitch";
  import * as Cookies from "js-cookie";
  import userPermission from '@/util/valueObjects/userPermission';

  export default {
    components: {
      SidebarToggleButton,
      CollapseTransition,
      BaseNav,
      Modal,
      BaseSwitch,
      Badge,
    },
    props: {
      notifications: {
        type: Array | Object
      },
      refresh: {
        default: false
      }
    },
    created() {
      let docClasses = document.body.classList;
      docClasses.add('white-content');
      this.companyName = this.token.user.company.fantasy_name

      if (this.token.user.permissions.includes(this.permission.FINANCE__FINTECH_COMMERCIAL.value))
        this.$set(this, 'userType', 'Comercial');
      else if (this.token.user.permissions.includes(this.permission.FINANCE__FINTECH_ANALYST.value))
        this.$set(this, 'userType', 'Analista');
      else
        this.$set(this, 'userType', 'Admin');
    },
    computed: {
      ...mapGetters({
        darkMode: "getColor"
      }),
      token() {
        return Cookies.getJSON("token");
      },
      routeName() {
        const { name } = this.$route;
        return this.$t('pages.shipper.title.'+name);
      },
      isRTL() {
        return this.$rtl.isRTL;
      },
      imageSrc(){
        if(this.token.user.company.avatar_path){

          return this.base+'/'+this.token.user.company.avatar_path;
        }else{
          return "/img/placeholder.jpg"
        }
      }
    },
    data() {
      return {
        companyName: '',
        darkModeSw: this.darkMode,
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',
        base: document.location.protocol + "//" + process.env.VUE_APP_API_HOST,
        permission: userPermission,
        userType: null,
        showNotifications: false,
      };
    },
    methods: {
      ...mapActions(["logout","setColorCookie"]),
      toggleMode(type) {
        this.setColorCookie(type);
        let docClasses = document.body.classList;
        if (type) {
          docClasses.remove('white-content');
        } else {
          docClasses.add('white-content');
        }
        this.darkModeSw =type;
      },
      async logoutSystem(){
        await this.logout();
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      showNotification() {
        this.$set(this, 'showNotifications', !this.showNotifications);
      },
      notificationRedirectTo(quotationId, notification) {
        // this.notificationResource.update(notification);
        this.$router.push({name: 'fintech.quotation_details', params: {id: quotationId}})
      },
      updatePage(){
        this.$emit('update-page')
      }
    }
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
  .icon-for-switch{
    line-height: inherit;
  }

  .float-notification {
    top:10px;
    right:95px;
    z-index:103;
  }

  .arrow_box {
    position:fixed;
    width:400px;
    height:380px;
    top:90px;
    right:27px;
    z-index:102;
    background: #FFF;
    border-radius: 10px;
    border: 4px solid #000000;
  }
  .arrow_box:after, .arrow_box:before {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #FFF;
    border-width: 30px;
    margin-left: 75px;
  }
  .arrow_box:before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #000000;
    border-width: 36px;
    margin-left: 69px;
  }

  .notification-list {
    margin-top: 10px;
    margin-left: 6px;
    margin-right: 6px;
    padding-right: 6px;
    height:350px;
    overflow-y: scroll;
  }
</style>
